import { render, staticRenderFns } from "./StaffCountCard.vue?vue&type=template&id=c2090196&scoped=true&"
import script from "./StaffCountCard.vue?vue&type=script&lang=js&"
export * from "./StaffCountCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2090196",
  null
  
)

export default component.exports